var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row q-col-gutter-md"},_vm._l((_vm.packages),function(item,index){return _c('package',{key:item.id,attrs:{"index":index,"package":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }